<template>
  <div style="display: inline">
    <h3>{{ $t("travelService.contactConsultants") }}:</h3>
    <v-sheet color="gray" max-width="400px" elevation="5" class="ma-4 px-4" v-for="(contact, index) of contactPersons" :key="index">
      <v-row>
        <v-col cols="4" class="pa-3">
          <v-icon style="font-size: 90px">fa-user-circle</v-icon>
        </v-col>
        <v-col cols="8" class="pa-4">
          <h2 class="mt-6">{{ contact.fullName }}</h2>
          <!--          <v-row>-->
          <!--            <a :href="'mailto: ' + contact.email">{{ contact.email }}</a>-->
          <!--          </v-row>-->
          <!--          <v-row style="font-weight: 700" v-if="contact.phone !== null && contact.phone.length>3"> +{{ contact.phone }} </v-row>-->
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "ClientViewOfferHistory",
  props: {
    offers: { required: true, type: Array }
  },
  computed: {
    contactPersons() {
      let contacts = [];
      for (let itemServiceOffer of this.offers) {
        if (contacts.filter(v => v.fullName === itemServiceOffer.created_by_name).length === 0) {
          contacts.push({ fullName: itemServiceOffer.created_by_name, email: itemServiceOffer.created_by_email, phone: itemServiceOffer.created_by_phone });
        }
        if (contacts.filter(v => v.fullName === itemServiceOffer.last_edit_by_name).length === 0) {
          contacts.push({
            fullName: itemServiceOffer.last_edit_by_name,
            email: itemServiceOffer.last_edit_by_email,
            phone: itemServiceOffer.last_edit_by_phone
          });
        }
      }
      return contacts;
    }
  }
};
</script>

<style scoped></style>
